import React, { useEffect } from 'react';
import { AllowedSidebarMap, useSidebar } from '../../../hooks';
import { globalAllowedSidebars } from '../../../common-sidebars';
import './app-page.scss';

interface Props extends React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  allowedSidebars?: AllowedSidebarMap;
}

/**
 * Application page wrapper for the pages within CASSI
 */
const AppPage = ({ children, className, allowedSidebars, ...props }: Props) => {
  const componentClassName = `app-page ${className ?? ''}`.trim();
  const { addToAllowlistSidebars, closeSidebar, clearSidebars } = useSidebar();

  useEffect(() => {
    addToAllowlistSidebars({
      ...allowedSidebars,
      ...globalAllowedSidebars,
    });
  }, [addToAllowlistSidebars, closeSidebar, allowedSidebars]);

  useEffect(() => {
    return () => {
      closeSidebar();
      if (!allowedSidebars) return;
      clearSidebars(allowedSidebars);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="app-page" {...props} className={componentClassName}>
      {children}
    </div>
  );
};

export default AppPage;
